import { Table } from 'antd';
import styled from 'styled-components';
import BaseWidgetActionComponent from '../components/WidgetActionComponent';
import BaseDropdown from '../../../components/Dropdown';
import BaseTooltip from '../components/Tooltip';

export const TransactionDetalisPanel = styled.div`
  background: #fff;
  border-radius: 5px;
  margin-bottom: 24px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);

  .ant-radio-button-wrapper,
  .ant-picker,
  .ant-tabs,
  .ant-picker-input > input {
    font-size: 13px;
  }
  .ant-collapse-header {
    display: flex;
    align-items: center;
  }

  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-thead {
    tr {
      .ant-table-cell {
        padding: 0.5rem;
        border-top: 1px solid #d5dee7;
        border-bottom: 1px solid #d5dee7;
        border-left: 1px solid #d5dee7;
        background: #eef4fa;
        vertical-align: top;
        font-size: 10px;
        font-weight: 500;
        font-style: normal;
        line-height: 12px;
        color: #556069;
        &:last-of-type {
          border-right: 1px solid #d5dee7;
        }
      }
    }
  }
  .ant-table-tbody {
    tr {
      .ant-table-cell {
        padding: 0.75rem 0.5rem;
        font-style: normal;
        font-weight: normal;
        font-size: 11px;
        line-height: 12px;
        color: #556069;
        strong {
          font-weight: 500;
        }
      }

      &:last-of-type {
        td {
          border-bottom: 1px solid #d5dee7;
        }
      }
    }
  }
  .ant-pagination {
    .ant-pagination-item {
      color: #31394d;
      border-radius: 4px;
    }
    .ant-pagination-item-active {
      color: #21b4bd;
      border-color: #21b4bd;
    }

    .ant-pagination-total-text {
      color: #b8bec5;
      line-height: 2rem;
    }

    .ant-pagination-item-link {
      border-radius: 4px;
    }
    .anticon {
      vertical-align: text-top;
    }
  }
`;

export const DownloadCSVWrapper = styled.div`
  float: right;
  margin-right: 16px;
`;

export const TransactionDetalisPanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const TransactionDetalisPanelTitle = styled.div`
  font-size: 16px;
  line-height: 19px;
  font-weight: 500;
`;

export const TransactionDetailsTable = styled(Table)`
  .ant-table .ant-table-container table .ant-table-tbody .ant-table-cell {
    font-size: 10px;
  }
`;

export const WidgetActionComponent = styled(BaseWidgetActionComponent)`
  margin-top: 0;
  margin-bottom: 0;
  width: auto;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const ActionItem = styled.div`
  margin-right: 40px;

  &:last-child {
    margin-right: 0;
  }
`;

export const ActionLabel = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: #748aa1;
  font-weight: 400;
  margin-bottom: 5px;
`;

export const Dropdown = styled(BaseDropdown)`
  & > div:first-child {
    border-radius: 4px;
    border-color: #d0d7e3;
    height: 24px;
    line-height: 18px;

    & > i {
      line-height: 18px;
    }
  }
`;

export const Tooltip = styled(BaseTooltip)`
  display: inline-block;
`;
